<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="validate">
        <div class="row">
          <div class="col-12">
            <ValidationProvider
              name="staffposition"
              rules="required"
            >
              <fg-input
                slot-scope="{ errors }"
                :error="errors[0] ? 'Please select what your role will be on this course': ''"
              >
                <label>Role On Course <span class="text-danger">*</span></label>
                <el-select
                  class="select-default2"
                  size="large"
                  name="staffposition"
                  placeholder=""
                  v-model="userSetupInfo.StaffPositionId"
                >
                  <el-option
                    class="select-default2"
                    value="1"
                    label="Course Director"
                  />
                  <el-option
                    class="select-default2"
                    value="2"
                    label="ASM Programs"
                  />
                  <el-option
                    class="select-default2"
                    value="3"
                    label="ASM Logistics"
                  />
                  <el-option
                    class="select-default2"
                    value="4"
                    label="ASM Troop Guides"
                  />
                  <el-option
                    class="select-default2"
                    value="5"
                    label="Scribe"
                  />
                </el-select>
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="participantPrice"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <label>Participant Price <span class="text-danger">*</span></label>
              <fg-input
                name="participantPrice"
                :error="failed ? 'Participant Price is required.': null"
                :has-success="passed"
                type="number"
                required
                placeholder=""
                v-model="courseSetupInfo.ParticipantPrice"
              >
                <template slot="addonLeft">
                  $
                </template>
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="staffPrice"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <label>Staff Price <span class="text-danger">*</span></label>
              <fg-input
                name="staffPrice"
                :error="failed ? 'Staff Price is required.': null"
                :has-success="passed"
                type="number"
                required
                placeholder=""
                v-model="courseSetupInfo.StaffPrice"
              >
                <template slot="addonLeft">
                  $
                </template>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>

export default {
  name: 'CourseCreationScouterInfo',
  data: function () {
    return {
      password2: '',
      courseSetupInfo: {
        StaffPrice: 0,
        ParticipantPrice: 0
      },
      userSetupInfo: {
        StaffPositionId: null
      }
    }
  },
  methods: {
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.$emit('on-validated', res, 'userSetupInfo', this.userSetupInfo)
        this.$emit('on-validated', res, 'courseSetupInfo', this.courseSetupInfo)
        return res
      })
    }
  }
}
</script>
